import React from 'react';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { resolveArguments } from 'apps/auth/helpers/utils';

export const KYCModal = (props) => {
    return (
        <ModalComponent canCloseModal={false} isVerticalCentered={true}>
            <InfoPage
                insideModalComponent={props.insideModalComponent}
                iconName="id-card-80"
                iconColor="primary"
                headerText={
                    <>
                        <span className="color-GT">{resolveArguments(props.profilePurpleBlock, props.aml_level_name)}</span>&nbsp;
                        {props.increase_block}
                    </>
                }
                secondaryText={props.increase_sub_block}
                topButtonCaption={props.notificationButton}
                topButtonOnClick={props.onClickNotNow}
                primaryButtonType="link"
                primaryButtonCaption={props.nextButton}
                primaryButtonOnClick={props.onClickContinue}
                primaryButtonLink={props.nextButtonLink}
            />
        </ModalComponent>
    );
};

export default KYCModal;
